"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var VariableValueConverter_1 = require("./VariableValueConverter");

var VariableDictionaryConverter =
/** @class */
function () {
  function VariableDictionaryConverter() {}

  VariableDictionaryConverter.prototype.fromMessage = function (message) {
    var object = {};

    for (var key in message) {
      object[key] = VariableValueConverter_1.variableValueConverter.fromMessage(message[key]);
    }

    return object;
  };

  VariableDictionaryConverter.prototype.toMessage = function (object) {
    var message = {};

    for (var key in object.variables) {
      message[key] = VariableValueConverter_1.variableValueConverter.toMessage(object[key]);
    }

    return object;
  };

  return VariableDictionaryConverter;
}();

exports.VariableDictionaryConverter = VariableDictionaryConverter;
exports.variableDictionaryConverter = new VariableDictionaryConverter();